export function eventImage(event) {
  return event?.promo?.post || event?.promo?.banner || event?.promo?.story || '';
}

export function eventPlace(event) {
  const venue = event?.organization?.name || '';
  const street = event?.address || event?.organization?.address || '';
  const city = event?.city || event?.organization?.city || '';
  const state = event?.state || event?.organization?.state || '';
  const locality = [city, state].filter(Boolean).join(', ');
  const address = [street, locality].filter(Boolean).join(', ');
  return {
    venue,
    address,
    line: [venue, address].filter(Boolean).join(' · '),
  };
}
